<template>
  <v-card flat class="pa-1 position-relative">
    <block v-if="loading"></block>

    <v-card class="pa-4 white component-v-card">
      <GeneralFilter
        @loading="loading = $event"
        :filterEndpoint="searchLocations"
        :search="search"
        @emptyFilter="resetFilters"
        @filtered="handleFilteredResponse"
        :columnsFilterEndpoint="loadLocationInventory"
        :columns.sync="filterColumns"
        :advancedFilter="true"
        :showAllRecords="search.showAllRecords"
        @onShowAllRecordsChange="handleShowAllRecordsChange"
      >
        <template #options>
          <v-row class="ma-0 mb-4" style="gap: 12px; align-items: center;">
            <v-col cols="12" md="3">
              <v-btn class="btn-save" @click="openLocationManager(selectedWarehouseId, 'general')">
                <v-icon left>mdi-warehouse</v-icon>
                Gestionar ubicaciones
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template #complementFilters>
          <div class="pt-2">
            <v-checkbox
              v-model="search.showAllRecords"
              @change="handleShowAllRecordsChange"
              label="Mostrar todos los registros (sin límite de 100)"
              dense
              hide-details="auto"
            ></v-checkbox>
          </div>
        </template>
      </GeneralFilter>

      <div class="d-flex flex-wrap align-center mb-2 mx-3" style="gap: 12px;">
        <div class="d-flex align-center" style="gap: 8px; min-width: 340px; max-width: 460px;">
          <v-autocomplete
            v-model="bulkLocationId"
            :items="bulkLocations"
            item-text="location"
            item-value="ID_location"
            outlined
            dense
            hide-details
            :disabled="!selectedWarehouseId"
            label="Ubicación masiva"
            @focus="loadBulkLocations"
          ></v-autocomplete>
          <v-btn
            class="btn-save"
            x-small
            :disabled="!selectedWarehouseId"
            @click="openLocationManager(selectedWarehouseId, 'general')"
          >
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
        </div>
        <v-btn
          class="btnclean"
          :disabled="!items.length"
          @click="toggleSelectAllRows"
        >
          <v-icon left>{{ allVisibleSelected ? "mdi-checkbox-multiple-blank-outline" : "mdi-checkbox-multiple-marked" }}</v-icon>
          {{ allVisibleSelected ? "Limpiar selección" : "Seleccionar todos" }}
        </v-btn>
        <v-btn
          class="btn-save"
          :disabled="!canApplyBulk || !selectedItems.length"
          @click="applyBulkLocation('selected')"
        >
          Aplicar a seleccionados
        </v-btn>
      </div>

      <DxDataGrid
        :data-source="items"
        key-expr="rowKey"
        :show-row-lines="true"
        :show-borders="true"
        :row-alternation-enabled="true"
        :column-auto-width="true"
      >
        <DxScrolling row-rendering-mode="virtual" />
        <DxPaging :page-size="10" />

        <DxColumn :width="80" cell-template="select-row" caption=""></DxColumn>
        <DxColumn data-field="ID_Item" caption="ID Producto"></DxColumn>
        <DxColumn data-field="PrincipalBarCode" caption="Codigo alt"></DxColumn>
        <DxColumn data-field="ItemName" caption="Nombre"></DxColumn>
        <DxColumn data-field="ID_ItemBatch" caption="Lote"></DxColumn>
        <DxColumn data-field="TotalStock" caption="Disponible"></DxColumn>
        <DxColumn cell-template="assign-location" caption="Ubicacion selector" :min-width="320"></DxColumn>
        <DxColumn data-field="WarehouseName" caption="Almacen"></DxColumn>
        <DxColumn data-field="locationCode" caption="Codigo Ubicacion"></DxColumn>
        <DxColumn data-field="location" caption="Nombre ubicacion"></DxColumn>
        <DxColumn data-field="familyName" caption="Familia"></DxColumn>
        <DxColumn data-field="categoryName" caption="Categoria"></DxColumn>
        <DxColumn data-field="subcategoryName" caption="Sub categoria"></DxColumn>

        <template #select-row="{ data }">
          <v-checkbox
            :input-value="isRowSelected(data.data)"
            @change="toggleRowSelection(data.data, $event)"
            style="height: 20px; width: 20px; padding: 0; margin-inline: auto;"
          ></v-checkbox>
        </template>

        <template #assign-location="{ data }">
          <div class="d-flex align-center" style="gap: 8px; min-width: 300px;">
            <v-autocomplete
              :value="data.data.location_id"
              :items="data.data.availableLocations || []"
              item-text="location"
              item-value="ID_location"
              outlined
              dense
              hide-details
              :loading="data.data.loadingLocations || data.data.applyingLocation"
              label="Seleccionar ubicación"
              @focus="prepareRowLocations(data.data)"
              @change="(value) => handleRowLocationChange(value, data.data)"
            ></v-autocomplete>
            <v-btn
              class="btn-save"
              x-small
              :disabled="!getRowWarehouseId(data.data)"
              @click="openLocationManager(getRowWarehouseId(data.data), 'row', data.data)"
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>
      </DxDataGrid>
    </v-card>

    <WarehouseLocationManagerDialog
      v-model="showLocationManager"
      :initial-warehouse-id="locationManagerWarehouseId"
      :selection-mode="true"
      :auto-select-on-create="true"
      @location-selected="handleLocationSelected"
      @locations-updated="handleLocationsUpdated"
    />

    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
  </v-card>
</template>
<script>
import { DxDataGrid, DxColumn, DxScrolling, DxPaging } from "devextreme-vue/data-grid";
import Alerts from "@/components/Alerts.vue";
import Block from "@/components/Block.vue";
import GeneralFilter from "@/components/GeneralFilter";
import WarehouseLocationManagerDialog from "@/components/inventory/WarehouseLocationManagerDialog.vue";

export default {
  name: "LocationEdition",
  components: {
    Alerts,
    Block,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    GeneralFilter,
    WarehouseLocationManagerDialog,
  },
  data() {
    return {
      loading: false,
      items: [],
      warehouses: [],
      defaultWarehouseId: null,
      families: [],
      categories: [],
      subcategories: [],
      selectedWarehouse: null,
      selectedRowKeys: [],
      bulkLocationId: null,
      bulkLocations: [],
      warehouseLocationsCache: {},
      showLocationManager: false,
      locationManagerWarehouseId: null,
      locationManagerContext: {
        type: "general",
        rowKey: null,
      },
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      search: {
        filter: null,
        business: "",
        branch: "",
        showAllRecords: false,
        showMin: false,
        showMax: false,
        orderProveedor: false,
        orderCodAlterno: false,
        allRecords: false,
        hideZeroBatches: false,
        hideBatches: false,
      },
      filterColumns: [
        {
          name: "ID_Warehouse",
          title: "Almacen",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "family",
          title: "Familia",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "category",
          title: "Categoria",
          value: "",
          parent: "family",
          type: "select",
          options: [],
        },
        {
          name: "subcategory",
          title: "Subcategoria",
          value: "",
          parent: "category",
          type: "select",
          options: [],
        },
        {
          name: "ID_ItemBatch",
          title: "Lote",
          value: "",
          type: "text",
          options: [],
        },
      ],
      oldFilterColumnsState: [],
    };
  },
  computed: {
    selectedItems() {
      return this.items.filter((item) => this.selectedRowKeys.includes(item.rowKey));
    },
    selectedWarehouseId() {
      return this.filterColumns[0]?.value || this.selectedWarehouse || null;
    },
    canApplyBulk() {
      return !!this.selectedWarehouseId && !!this.bulkLocationId;
    },
    allVisibleSelected() {
      return this.items.length > 0 && this.selectedRowKeys.length === this.items.length;
    },
  },
  watch: {
    filterColumns: {
      handler(newVal) {
        newVal.forEach((newItem, index) => {
          const oldItem = this.oldFilterColumnsState[index];

          if (oldItem && newItem.value !== oldItem.value && index === 0) {
            this.selectedWarehouse = newItem.value || null;
            this.bulkLocationId = null;
            this.loadBulkLocations();
          }

          if (oldItem && newItem.value !== oldItem.value && index === 1) {
            this.filterColumns[2].options = this.categories
              .filter((category) => category.id_family == newItem.value)
              .map((category) => ({
                name: category.name,
                value: category.id,
                parent_id: category.id_family,
              }));
            this.filterColumns[2].value = "";
            this.filterColumns[3].value = "";
            this.filterColumns[3].options = [];
          }

          if (oldItem && newItem.value !== oldItem.value && index === 2) {
            this.filterColumns[3].options = this.subcategories
              .filter((subcategory) => subcategory.id_cat == newItem.value)
              .map((subcategory) => ({
                name: subcategory.name,
                value: subcategory.id,
                parent_id: subcategory.id_cat,
              }));
            this.filterColumns[3].value = "";
          }
        });

        this.oldFilterColumnsState = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
    },
  },
  created() {
    this.oldFilterColumnsState = JSON.parse(JSON.stringify(this.filterColumns));
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    this.search.business = user.businessid || "";
    this.search.branch = user.branch || "";

    this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
      this.loading = true;

      try {
        await Promise.all([
          this.getWarehouses(),
          this.getFamilies(),
          this.getCategories(),
          this.getSubcategories(),
        ]);

        await this.loadLocationInventory();
        await this.loadBulkLocations();
      } finally {
        this.loading = false;
      }
    },
    showAlert(type, header, body, options = null) {
      this.alert.type = type || "danger";
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options;
    },
    closeAlert() {
      this.alert.show = false;
    },
    acceptAlert() {
      this.alert.show = false;
    },
    normalizeLocation(location) {
      return {
        ...location,
        ID_location: Number(location.ID_location || location.ID_Location),
        location: location.location || location.LocationName,
        locationCode: location.locationCode || location.LocationCode || "",
      };
    },
    prepareItems(items = []) {
      return items.map((item, index) => {
        const warehouseId = this.getRowWarehouseId(item);
        const cachedLocations = warehouseId
          ? this.warehouseLocationsCache[String(warehouseId)] || []
          : [];

        return {
          ...item,
          location: item.location || item.LocationName || "",
          locationCode: item.locationCode || "",
          rowKey: [
            item.ID_Inventory || index,
            item.ID_Item || index,
            warehouseId || "warehouse",
            item.ID_ItemBatch || "batch",
          ].join("-"),
          availableLocations: cachedLocations,
          loadingLocations: false,
          applyingLocation: false,
        };
      });
    },
    setItems(items = []) {
      this.items = this.prepareItems(items);
      this.selectedRowKeys = this.selectedRowKeys.filter((rowKey) =>
        this.items.some((item) => item.rowKey === rowKey)
      );
      this.hydrateRowsLocations();
    },
    getRowWarehouseId(row) {
      return row.Warehouse || row.ID_Warehouse || null;
    },
    async getWarehouses() {
      const response = await this.$API.warehouse.getWarehouses({
        business: this.search.business,
        branch: this.search.branch,
      });

      this.warehouses = response || [];
      this.filterColumns[0].options = this.warehouses.map((warehouse) => ({
        name: warehouse.Warehouse,
        value: warehouse.ID_Warehouse,
      }));

      if (!this.selectedWarehouse) {
        const activeWarehouse = this.warehouses.find(
          (warehouse) =>
            warehouse.Active === true &&
            parseInt(warehouse.ID_Branch) === parseInt(this.search.branch)
        );

        if (activeWarehouse) {
          this.defaultWarehouseId = activeWarehouse.ID_Warehouse;
          this.selectedWarehouse = activeWarehouse.ID_Warehouse;
          this.filterColumns[0].value = activeWarehouse.ID_Warehouse;
        }
      }
    },
    async getFamilies() {
      const response = await this.$API.itemtypes.getFamilies();
      this.families = response || [];
      this.filterColumns[1].options = this.families.map((family) => ({
        name: family.name,
        value: family.id,
      }));
    },
    async getCategories() {
      this.categories = (await this.$API.itemtypes.getCategories()) || [];
    },
    async getSubcategories() {
      this.subcategories = (await this.$API.itemtypes.getSubs()) || [];
    },
    async getLocationsForWarehouse(warehouseId, force = false) {
      if (!warehouseId) {
        return [];
      }

      const key = String(warehouseId);

      if (!force && this.warehouseLocationsCache[key]) {
        return this.warehouseLocationsCache[key];
      }

      const response = await this.$API.inventoryWarehouseLocations.getByWarehouse({
        warehouseId,
      });

      const normalized = (response || []).map((location) => this.normalizeLocation(location));
      this.$set(this.warehouseLocationsCache, key, normalized);

      this.items.forEach((item) => {
        if (String(this.getRowWarehouseId(item)) === key) {
          item.availableLocations = normalized;
        }
      });

      return normalized;
    },
    async hydrateRowsLocations(rows = this.items) {
      const warehouseIds = [...new Set(
        (rows || [])
          .map((row) => this.getRowWarehouseId(row))
          .filter((warehouseId) => warehouseId !== null && warehouseId !== undefined && warehouseId !== "")
          .map((warehouseId) => String(warehouseId))
      )];

      if (!warehouseIds.length) {
        return;
      }

      await Promise.all(
        warehouseIds.map((warehouseId) => this.getLocationsForWarehouse(warehouseId))
      );
    },
    async loadBulkLocations() {
      if (!this.selectedWarehouseId) {
        this.bulkLocations = [];
        this.bulkLocationId = null;
        return;
      }

      this.bulkLocations = await this.getLocationsForWarehouse(this.selectedWarehouseId);
    },
    buildColumnsPayload() {
      const columns = this.filterColumns
        .filter((column) => column.value !== null && column.value !== undefined && column.value !== "")
        .map((column) => ({
          name: column.name,
          value: column.value,
          type: column.type,
        }));

      if (
        this.selectedWarehouse &&
        !columns.some((column) => column.name === "ID_Warehouse")
      ) {
        columns.unshift({
          name: "ID_Warehouse",
          value: this.selectedWarehouse,
          type: "select",
        });
      }

      return JSON.stringify(columns);
    },
    buildRequestPayload() {
      return {
        filter: this.buildColumnsPayload(),
        business: this.search.business,
        branch: this.search.branch,
        search: JSON.stringify(this.search),
        like: this.search.filter || null,
        selectedItem: null,
        dates: JSON.stringify({ oneDate: null }),
        hideNoStockRecords: false,
      };
    },
    loadLocationInventory() {
      this.loading = true;

      return this.$API.inventoryReports
        .searchInventoryLocationEdition(this.buildRequestPayload())
        .then((response) => {
          this.setItems(response || []);
          return response || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchLocations(params) {
      this.search = {
        ...this.search,
        ...params,
      };

      return this.loadLocationInventory();
    },
    handleFilteredResponse(response) {
      this.setItems(response || []);
    },
    isRowSelected(row) {
      return this.selectedRowKeys.includes(row.rowKey);
    },
    toggleRowSelection(row, value) {
      if (value) {
        if (!this.selectedRowKeys.includes(row.rowKey)) {
          this.selectedRowKeys.push(row.rowKey);
        }
        return;
      }

      this.selectedRowKeys = this.selectedRowKeys.filter((rowKey) => rowKey !== row.rowKey);
    },
    toggleSelectAllRows() {
      if (this.allVisibleSelected) {
        this.selectedRowKeys = [];
        return;
      }

      this.selectedRowKeys = this.items.map((item) => item.rowKey);
    },
    async prepareRowLocations(row) {
      const warehouseId = this.getRowWarehouseId(row);

      if (!warehouseId || row.loadingLocations) {
        return;
      }

      row.loadingLocations = true;

      try {
        row.availableLocations = await this.getLocationsForWarehouse(warehouseId);
      } finally {
        row.loadingLocations = false;
      }
    },
    async assignLocations(assignments, successMessage = null) {
      if (!assignments.length) {
        return;
      }

      this.loading = true;

      try {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        await this.$API.inventoryWarehouseLocations.assign({
          assignments,
          user: user.id,
        });

        if (successMessage) {
          this.showAlert("success", "Ubicaciones", successMessage);
        }
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Ubicaciones", error || "No se pudo asignar la ubicación.");
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async handleRowLocationChange(locationId, row) {
      if (!locationId || String(locationId) === String(row.location_id)) {
        return;
      }

      row.applyingLocation = true;

      try {
        await this.prepareRowLocations(row);
        await this.assignLocations([
          {
            inventoryId: row.ID_Inventory,
            locationId,
          },
        ]);

        const location = (row.availableLocations || []).find(
          (current) => String(current.ID_location) === String(locationId)
        );

        row.location_id = locationId;
        row.location = location ? location.location : row.location;
        row.locationCode = location ? location.locationCode : row.locationCode;
      } finally {
        row.applyingLocation = false;
      }
    },
    async applyBulkLocation(mode) {
      const warehouseId = this.selectedWarehouseId;

      if (!warehouseId || !this.bulkLocationId) {
        this.showAlert("warning", "Ubicaciones", "Seleccione una bodega y una ubicación.");
        return;
      }

      const baseRows = mode === "selected" ? this.selectedItems : this.items;
      const rows = baseRows.filter(
        (row) => String(this.getRowWarehouseId(row)) === String(warehouseId)
      );

      if (!rows.length) {
        this.showAlert("warning", "Ubicaciones", "No hay registros válidos para aplicar la ubicación.");
        return;
      }

      const assignments = rows.map((row) => ({
        inventoryId: row.ID_Inventory,
        locationId: this.bulkLocationId,
      }));

      await this.assignLocations(
        assignments,
        mode === "selected"
          ? "La ubicación se asignó a los registros seleccionados."
          : "La ubicación se asignó a todos los registros visibles de la bodega."
      );

      const location = this.bulkLocations.find(
        (current) => String(current.ID_location) === String(this.bulkLocationId)
      );

      rows.forEach((row) => {
        row.location_id = this.bulkLocationId;
        row.location = location ? location.location : row.location;
        row.locationCode = location ? location.locationCode : row.locationCode;
      });
    },
    openLocationManager(warehouseId = null, type = "general", row = null) {
      this.locationManagerWarehouseId = warehouseId;
      this.locationManagerContext = {
        type,
        rowKey: row ? row.rowKey : null,
      };
      this.showLocationManager = true;
    },
    async handleLocationSelected(location) {
      const normalized = this.normalizeLocation(location);
      const warehouseId = this.locationManagerWarehouseId || this.selectedWarehouseId;

      await this.getLocationsForWarehouse(warehouseId, true);
      await this.loadBulkLocations();

      if (this.locationManagerContext.type === "row") {
        const row = this.items.find((item) => item.rowKey === this.locationManagerContext.rowKey);

        if (row) {
          row.availableLocations = await this.getLocationsForWarehouse(this.getRowWarehouseId(row));
          await this.handleRowLocationChange(normalized.ID_location, row);
        }
        return;
      }

      this.bulkLocationId = normalized.ID_location;
    },
    async handleLocationsUpdated(payload = {}) {
      const warehouseId = payload.warehouseId || this.locationManagerWarehouseId || this.selectedWarehouseId;

      if (warehouseId) {
        await this.getLocationsForWarehouse(warehouseId, true);
      }

      await this.loadBulkLocations();
      await this.loadLocationInventory();
    },
    resetFilters() {
      this.search = {
        ...this.search,
        filter: null,
        showAllRecords: false,
        allRecords: false,
      };
      this.selectedWarehouse = this.defaultWarehouseId || this.selectedWarehouse || null;
      this.bulkLocationId = null;
      this.filterColumns = this.filterColumns.map((column, index) => ({
        ...column,
        value: index === 0 && this.defaultWarehouseId ? this.defaultWarehouseId : "",
        options:
          index === 2 || index === 3
            ? []
            : column.options,
      }));

      this.oldFilterColumnsState = JSON.parse(JSON.stringify(this.filterColumns));
      return Promise.all([
        this.loadBulkLocations(),
        this.loadLocationInventory(),
      ]);
    },
    handleShowAllRecordsChange(value) {
      this.search.showAllRecords = value;
      this.search.allRecords = value;
      this.loadLocationInventory();
    },
  },
};
</script>
